/*
 * @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @Deion:
 * @Date: 2022-09-19 10:36:26
 * @LastEditors: guanxiaoyan guanxiaoyan@pb-station.com
 * @LastEditTime: 2023-12-07 15:17:06
 * @FilePath: /ywx-open/vue/src/api/agent.js
 */
/*
 * *代理商api
 * * 添加日期:2022/09/19
 */
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import API from '@szyx/axios'
Vue.use(VueCookies)
/** *************** 3代理商和4代理商销api (没有环境切换)************************************ */
const envApi = VueCookies.get('envApi')

export default {
  // 账户概览
  agentAccountOverView: (params) =>
    API.GET(`/openapi/user/accountOverView`, params),
  // 预警统计数量
  getWarnStatisticsNumApi: (params) =>
    API.GET(`/${envApi}/firm/getPackageWarningTotal`, params),
  // 预警列表数据
  getWarnStaticsListApi: (params) =>
    API.POSTJSON(`/${envApi}/firm/getPackageWarningPage`, params),
    getWarnStaticsListApi_new: (params) =>
    API.POSTJSON(`/${envApi}/firm/getPackageWarningPageNew`, params),
  exportWarnStaticListApi: (params) =>
    API.POSTJSON(`/${envApi}/firm/exportPackageWarning`, params, {
      responseType: 'blob',
    }),
  // 获取代理商下属厂商组列表
  getFirmGroupListApi: (params) =>
    API.GET(`/${envApi}/firm/getFirmGroupList`, params),
  // 某渠道下的厂商列表
  firmByAgent: (params) => API.GET(`/${envApi}/firm/getFirmByAgent`, params),
  // 获取销售列表
  getSaleListApi: (params) => API.GET(`/${envApi}/firm/salePersonList`, params),
  /***************************服务详情************************************/
  // 医生签名订单列表
  doctorSignListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/doctorSign/list`, params),
  // 医师签名订单详情
  doctorSignDetailByAgent: (params) =>
    API.GET(`/${envApi}/doctorSign/detail`, params),
  // 补偿通知（open）
  msgRepeatSendByAgent: (params) =>
    API.POSTFROM(`/${envApi}/doctorSign/msgRepeatSend`, params),
  // 获取厂商签名订单（open）
  firmSignListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/order/firmSign/list`, params),
  // 厂商签名订单详情（open
  firmSignDetailByAgent: (params) =>
    API.POSTFROM(`/${envApi}/order/firmSign/detail`, params),
  // 患者签名-订单列表（openapi）
  patientSignListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/patient/sign/getListByPage`, params),
  // 患者签名-订单详情（open）
  patientSignDetailByAgent: (params) =>
    API.GET(`/${envApi}/patient/sign/getSignDetail`, params),
  // 患者签名补偿回调（open）
  patientMsgRepeatSendByAgent: (params) =>
    API.POSTFROM(`/${envApi}/patient/sign/msgRepeatSend`, params),
  // 授权记录分页查询
  authorizationRecordListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/grant/listByPage`, params),
  // 授权签名分页查询
  authorizationRecordDetailByAgent: (params) =>
    API.POSTJSON(`/${envApi}/grant/getSignList`, params),
  // 回调服务状态————医生
  doctorCallManagerListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/callManager/firmNotifyPage`, params),
  // 回调服务状态————-患者
  // patientCallManagerListByAgent: (params) =>
  //   API.POSTJSON(`/${envApi}/callManager/firmNotifyPage`, params),
  // 回调服务状态————医师签名数据回调补偿（open）
  doctorCallManagerMakeUpByAgent: (params) =>
    API.GET(`/${envApi}/callManager/makeUpByclientId`, params),
  // 回调服务状态————用户状态回调失败详情（open）
  userCallFailedListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/callManager/getUserCallFailedPage`, params),
  // 回调服务状态————用户再次通知回调（open）
  relapseDocNotifyByAgent: (params) =>
    API.POSTJSON(`/${envApi}/callManager/relapseDocNotify`, params),
  // 回调服务状态————用户批量补偿接口（open）
  retryDoctorNotifyByAgent: (params) =>
    API.GET(`/${envApi}/callManager/notify/retryDoctorNotify`, params),
  // 患者签名批量补偿（open）
  batchMakeUpPatientSignByAgent: (params) =>
    API.GET(`/${envApi}/callManager/batchMakeUpPatientSign`, params),
  // 回调服务状态————患者回调服务状态列表（open
  patientCallManagerMakeUpByAgent: (params) =>
    API.POSTJSON(`/${envApi}/callManager/getPatientNotifyStatusPage`, params),
  // 订阅服务列表（open）
  packageListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/package/getPackagePage`, params),
  // 订阅服务管理————按月统计凭证包使用量（open）
  monthStatisticsByAgent: (params) =>
    API.POSTFROM(`/${envApi}/package/monthStatistics`, params),
  // 订阅服务管理————导出（open）
  exportPackageByAgent: (params) =>
    API.POSTJSON(`/${envApi}/package/exportPackagePage`, params, {
      responseType: 'blob',
    }),
  // 订阅服务管理————详情--凭证包使用流水（open）
  costLoglistByAgent: (params) =>
    API.POSTJSON(`/${envApi}/package/costLoglist`, params),
  // 订阅服务管理--凭证包流水导出（open）
  exportCostLogByAgent: (params) =>
    API.POSTFROM(`/${envApi}/package/exportCostLog`, params, {
      responseType: 'blob',
    }),
  // 医师订单导出
  exportDoctorSignOrder: (params) =>
    API.POSTJSON(`/${envApi}/doctorSign/exportDoctorSignOrder`, params, {
      responseType: 'blob',
    }),
  // 客户订单导出
  exportFirmSign: (params) =>
    API.POSTJSON(`/${envApi}/order/firmSign/exportFirmSign`, params, {
      responseType: 'blob',
    }),
  // 患者订单导出
  exportPatientOrder: (params) =>
    API.POSTJSON(`/${envApi}/patient/sign/exportPatientOrder`, params, {
      responseType: 'blob',
    }),
  /***************************可信用户************************************/
  //   可信用户列表
  trustUserListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/doctor/trust/list`, params),
  //   可信用户——来源
  sourceListByAgent: (params) =>
    API.GET(`/${envApi}/doctor/source/list`, params),
  //   可信用户——回调
  truestUserCallBackByAgent: (params) =>
    API.POSTJSON(`/${envApi}/callManager/getUserCallPage`, params),
  // //   可信用户——回调——再次通知
  // relapseDocNotifyByAgent: (params) =>
  //   API.POSTJSON(`/${envApi}/callManager/relapseDocNotify`, params),
  //   可信用户———详情
  doctorDetailInfoByAgent: (params) =>
    API.POSTFROM(`/${envApi}/doctor/trust/getDoctorDetailInfo`, params),
  //   可信用户———删除用户
  delTrustUserByAgent: (params) =>
    API.GET(`/${envApi}/doctor/trust/del`, params),
  //   可信用户———导出
  exportTrustUserListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/doctor/trust/exportList`, params, {
      responseType: 'blob',
    }),
  // 修改手机号
  trustChangePhone: (params) =>
    API.POSTJSON(`/${envApi}/doctor/trust/changePhone`, params),
  /***************************初审用户************************************/
  //   可信用户列表
  preliminaryUserListByAgent: (params) =>
    API.POSTJSON(`/${envApi}/doctor/temp/list`, params),
  //   初审用户———删除用户
  delpreliminaryUserByAgent: (params) =>
    API.POSTFROM(`/${envApi}/doctor/temp/delete`, params),
  //   初审用户———审核
  auditPreliminaryUserByAgent: (params) =>
    API.POSTFROM(`/${envApi}/doctor/temp/getTempUserInfo`, params),
  //   初审用户———审核
  preliminaryUserRejectByAgent: (params) =>
    API.POSTFROM(`/${envApi}/doctor/temp/reject`, params),
  //   初审用户———审核
  preliminaryUserApproveByAgent: (params) =>
    API.POSTFROM(`/${envApi}/doctor/temp/approve`, params),

  //  初审用户———人工审核
  manualAuth: (params) => API.GET(`/${envApi}/doctor/temp/manualAuth`, params),
  /***************************客户管理************************************/
  //   可信客户列表
  firmListByAgent: (params) => API.POSTJSON(`/${envApi}/firm/list`, params),
  //   可信客户——详情
  initFirmInfoByAgent: (params) =>
    API.GET(`/${envApi}/firm/initFirmInfo`, params),
  //   可信客户——患者签名配置
  queryPatientConfigByAgent: (params) =>
    API.POSTFROM(`/${envApi}/firm/queryPatientConfig`, params),
  // 负责人列表
  listByOpAccByAgent: (params) =>
    API.GET(`/${envApi}/agent/sale/getListByOpAcc`, params),
  // 负责人列表
  modifyFirmInfoByAgent: (params) =>
    API.POSTJSON(`/${envApi}/firm/modifyFirmInfo`, params),
  // 可信客户——患者签名配置---修改接口
  addPatientConfigByAgent: (params) =>
    API.POSTJSON(`/${envApi}/firm/addPatientConfig`, params),

  // 可信客户——新增接口
  addFirmInfoByAgent: (params) =>
    API.POSTJSON(`/${envApi}/firm/addFirmInfo`, params),

  stampPreviewByAgent: (params) =>
    API.POSTJSON(`/${envApi}/firm/stampPreview`, params),
  // 厂商订阅服务url（open）
  firmServiceList: (params) =>
    API.POSTJSON(`/${envApi}/firm/getFirmServiceList`, params),
  // 通讯平台——监控地址--测试链接
  txLinkNotifyUrl: (params) =>
    API.POSTFROM(`/${envApi}/subService/linkNotifyUrl`, params),
  // 可信厂商列表-导出（open）
  exportByParam: (params) =>
    API.POSTJSON(`/${envApi}/firm/exportByParam`, params, {
      responseType: 'blob',
    }),
  // 保存订阅服务地址
  updateFirmNotifyUrl_agent: (params) =>
    API.POSTJSON(`/${envApi}/subService/updateFirmNotifyUrl`, params),
  // 代理商销售-列表
  getSaleList: (params) => API.POSTJSON(`/${envApi}/agent/sale/list`, params),
  // 代理商销售-删除
  delSale: (params) => {
    const url = `/${envApi}/agent/sale/del?uniqueid=${params.uniqueid}`
    return API.POSTJSON(url, params)
  },
  // 代理商销售-添加、修改
  addSale: (params) => API.POSTJSON(`/${envApi}/agent/sale/edit`, params),

  // 角色列表
  getListByPage: (params) =>
    API.POSTJSON(`/openapi/user/role/getListByPage`, params),

  // 添加角色
  roleAdd: (params) => API.POSTFROM(`/openapi/user/role/add`, params),

  // 角色列表
  roleDel: (params) => API.POSTFROM(`/openapi/user/role/del`, params),

  // 获取所有权限
  getPermissionsByAgentId: (params) =>
    API.GET(`/openapi/user/role/getPermissionsByAgentId`, params),

  // 根据角色id 获取权限
  getPermissionsByRoleId: (params) =>
    API.GET(`/openapi/user/role/getPermissionsByRoleId`, params),

  // 根据角色id 获取权限
  updatePerForRole: (params) =>
    API.POSTJSON(`/openapi/user/role/updatePerForRole`, params),
}
